import { module } from 'modujs';
import LazyLoad from "vanilla-lazyload";
import Lenis from '@studio-freight/lenis';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initScroll()
        this.lazyLoad()
    }

    initScroll() {
        this.scroll = new Lenis();

        const raf = (time) => {
            this.scroll.raf(time);
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf);
    }

    lazyLoad() {
        this.lazy = new LazyLoad({
            elements_selector: ".lazy",
            thresholds: "0% 0px"
        })
    }

    updateLazy() {
        this.lazy.update()
    }

    scrollTo(args) {
        this.scroll.scrollTo(args)
    }

    scrollTop(args) {
        this.scroll.scrollTo(0);
    }

    start() {
        this.scroll.start();
    }

    stop() {
        this.scroll.stop();
    }

    destroy() {
        this.scroll.destroy();
    }
}
